import React from 'react';

import { Article, Brand, CTA, Feature, Navbar } from './components';
import { Header, Footer, Blog, Possibility, WhatGPT5, Features } from './containers';
import './App.css';

const App = () => {
  return (
    <div className='App'>
      <div className='gradient_bg'>
        <Navbar />
        <Header />
      </div>
      <main>
        <Brand />
        <WhatGPT5 />
        <Features />
        <Possibility />
        <CTA />
        <Blog />
      </main>
      <Footer />
    </div>
  )
}

export default App